import React from 'react'
import createReactClass from 'create-react-class'
import toClassName  from '../../functions/to-class-name'

import CTA from '/js/components/cta'
import DateNav from '/js/components/datenav'
import MapLink from '/js/components/map-link'
import SharingButtons from '/js/components/sharing-buttons'
import Linkify from '/js/components/linkify'
import CommunityInfo from '/js/components/community-info'
import VendorCount from '/js/components/vendor-count'
import Banner from '/js/components/banner'
import SectionButtons from './section-buttons'
import './event-info.scss'

var Amenities = createReactClass( {
  getAmenities: function(){
    if(this.props.market.amenities)
      return this.props.market.amenities.map( function( type, id ){
        return (
          <li key={id} className={"amenity-type-" + id}>
            <span>{type.split(':')[1]}</span>
          </li>
        )
      } )
  },
  render: function(){
    return (
      <section className="amenities">
        <h4>Amenities:</h4>
        <ul>{this.getAmenities()}</ul>
      </section>
    )
  }
} )

export default createReactClass({
  formatMonthDay: function( month_day ){
    month_day = month_day.split('.')
    month_day = month_day.map( function( n ){
      return parseInt( n )
    })
    return month_day.join('/')
  },
  getUpcomingEvents: function(){
    /* this is no longer being used. Styles relating to this should be removed
     * along with thise code */
    if( this.props.market.events == undefined){
      return false
    }

    var events = this.props.market.events.slice( 0, 5 )
    return events.map( function( e, i ){
      return (
        <li key={i}>
            <span className="day highlight">{e.abbreviated_day_of_week} </span>
            <span className="date">{ this.formatMonthDay(e.month_day) }</span>
            <span className="time">{ e.hours + e.am_pm}</span>
            <VendorCount count={e.vendors.length} />
        </li>
      )
    }.bind(this))
  },
  formatStatus: function( status ) {
    switch( status ) {
      case 'opentoday':
        status = 'open today';
        break;
      case 'opennow':
        status = 'open now';
        break;
    }
    return status;
  },
  render: function(){
    const { banner, aboutCTA } = this.props
    const bannerLink = banner ? banner.link : {}
    return (
      <section className="event-info-wrap" itemScope itemType="http://schema.org/FoodEvent">
        <link itemProp="additionalType" href="http://schema.org/SocialEvent"/>
        <div className={this.props.market.events.length == 0 ? "event-dates-bar empty" : "row event-dates-bar"}>
          <div className="col-md-3 col-xs-12 u-hide-under-md event-additional-info">
          { this.props.market.status != 'closed' &&
              <div className="event-status-wrap">
                <span className={ toClassName( [
                  'button',
                  'button--small',
                  'button--disabled',
                  'event-status',
                  this.props.market.status,
                ] ) }>
                  <i className="fa fa-clock-o"></i>
                  { this.formatStatus(this.props.market.status) }
                </span>
              </div>
            }
          </div>
          <div className="col-md-9 col-xs-12 col-md-3">
              <h3 className={"events-date-title " }>Upcoming Events:</h3>
              <DateNav
                events={ this.props.market.events }
                setEvent={ this.props.setEvent }
                event={ this.props.event }
              />
          </div>
        </div>
        { banner &&
          <Banner
            align={ banner.alignment }
            message={ banner.text }
            url={ bannerLink.url }
            target={ bannerLink.target }
            title={ bannerLink.title }
          />
        }
        <div className="row">
          <div className="col-md-3 col-xs-12 u-hide-under-md event-additional-info">
            <SharingButtons shareText={ "Meet me at " + this.props.market.name + '!'} market={this.props.market}/>
            <SectionButtons displayRetailers={this.props.event.retailers} />
          </div>
          <div className="col-md-9 col-xs-12">
            <section
              className={
                "event-info " +
                "status-" + this.props.market.status + " " +
                "content-" + this.props.market.id
              } itemProp="location" itemScope itemType="http://schema.org/Place">
              <p>
                <meta itemProp="address" content={`${this.props.market.address}, ${this.props.market.city}`} />
                <MapLink
                  latitude={this.props.market.latitude}
                  longitude={this.props.market.longitude}
                  text={`${this.props.market.address}, ${this.props.market.city}`}
                />
              </p>
              <hr />
              <Linkify className="event--info-details" tagName="p">{this.props.market.about}</Linkify>
              <div className="share-buttons-mobile u-hide-md">
                <hr />
                <SharingButtons shareText={ "Meet me at " + this.props.market.name + '!'} market={this.props.market}/>
                <SectionButtons />
                <hr />
              </div>
            </section>
          </div>
        </div>
        { aboutCTA &&
          <div className="u-text-center">
            {
              aboutCTA.map( ( { analytics, button, gtm_id }, index ) => {
                const { target, title, url } = button ? button : {}
                return (
                  <CTA
                    className="button button--lg"
                    key={ `${gtm_id}${index}` }
                    id={ gtm_id }
                    url={ url }
                    fields={ analytics[0] }
                    target={ target }
                    >
                    {title}
                  </CTA>
                )
              } )
            }
          </div>
        }
        <CommunityInfo event={ this.props.event }  />
      </section>
    )
  }
})
